import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=22c1aa4e&scoped=true&"
import script from "./MainNavbar.vue?vue&type=script&lang=js&"
export * from "./MainNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=22c1aa4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1aa4e",
  null
  
)

export default component.exports